/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Blocks from '../blocks/Blocks';
import Next from '../buttons/Next';
import Date from './Date';
import Embed from './Embed';
import Html from './Html';
import Image from './Image';

import styles from '../../../styles/partials/article.module.scss';

const propTypes = {
    article: AppPropTypes.article,
    withControls: PropTypes.bool,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    article: null,
    withControls: false,
    onNext: null,
    onPrevious: null,
    className: null,
};

const Article = ({ article, withControls, onNext, onPrevious, className }) => {
    const {
        type = null,
        title = null,
        description = null,
        blocks = [],
        headerImage = null,
        publishedAt = null,
        embed = null,
    } = article || {};

    const { provider = null } = embed || {};
    const isVideoProvider = provider === 'youtube' || provider === 'vimeo';

    const isEmbed = type === 'embed' && embed !== null;
    const isVideo = (type === 'video' || isVideoProvider) && embed !== null;
    const isNewsletter = type === 'newsletter' && embed !== null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isVideo]: isVideo,
                    [styles[type]]: type !== null,
                    [className]: className !== null,
                },
            ])}
        >
            {headerImage !== null && !isVideo && !isEmbed ? (
                <Image className={styles.image} media={headerImage} ratio={0.5625} />
            ) : null}
            <div className={styles.inner}>
                {title !== null ? (
                    <h1 className={styles.main}>
                        <Html className={styles.title} body={title} />
                    </h1>
                ) : null}
                {publishedAt !== null ? <Date className={styles.date} date={publishedAt} /> : null}
                {description !== null ? (
                    <div className={styles.main}>
                        <Html className={styles.description} body={description} tag="p" />
                    </div>
                ) : null}
                {blocks.length > 0 ? (
                    <Blocks
                        className={styles.blocks}
                        blocks={blocks}
                        blockProps={{ disableAutoPlay: true }}
                    />
                ) : null}
            </div>
            {isEmbed || isNewsletter ? (
                <div
                    className={classNames([
                        styles.embedContainer,
                        {
                            [styles.isVideo]: isVideo,
                            [styles[provider]]: type !== null,
                        },
                    ])}
                >
                    <Embed
                        iframeClassName={styles.embed}
                        embed={embed}
                        size={isNewsletter ? { width: '100%', height: '66vh' } : null}
                    />
                </div>
            ) : null}
            {withControls ? (
                <div className={styles.controls}>
                    <Next
                        className={classNames([styles.button, styles.previous])}
                        direction="left"
                        onClick={onPrevious}
                        disabled={onPrevious === null}
                    />
                    <Next
                        className={classNames([styles.button, styles.next])}
                        onClick={onNext}
                        disabled={onNext === null}
                    />
                </div>
            ) : null}
        </div>
    );
};

Article.propTypes = propTypes;
Article.defaultProps = defaultProps;

export default Article;
